import React from 'react'
import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom'
import { ClientSignInPage } from 'src/pages/client/auth/ClientSignInPage'
import { ClientEnterCodePage } from 'src/pages/client/auth/ClientEnterCodePage'
import { ClientHomePage } from 'src/pages/client/ClientHome'
import { NotFoundPage } from 'src/pages/NotFoundPage'
import { LoggedOutPage } from 'src/pages/LoggedOutPage'
import { ClientDocsPage } from './pages/client/docs/ClientDocsPage'
import {
  CONTRACTOR_PORTAL_ROUTES,
  PRE_CLIENT_ROUTES,
  CLIENT_ROUTES,
  ONBOARDING_ROUTES,
  RECOLLECTION_ROUTES,
} from './constants/routes'
import { ClientSignUpPage } from './pages/client/auth/ClientSignUpPage'
import { AlreadyRegisteredPage } from './pages/AlreadyRegisteredPage'
import { PartnerDisabledPage } from './pages/PartnerDisabledPage'
import { ContractorPortalSignInPage } from './pages/contractorPortal/auth/ContractorPortalSignInPage'
import { ContractorPortalEnterCodePage } from './pages/contractorPortal/auth/ContractorPortalEnterCodePage'
import { ContractorPortalSelectPartnerPage } from './pages/contractorPortal/auth/ContractorPortalSelectPartnerPage'
import { ContractorPortalHomePage } from './pages/contractorPortal/ContractorPortalHomePage'
import { ContractorPortalInvoicesPage } from './pages/contractorPortal/ContractorPortalInvoicesPage'
import { ContractorPortalDocumentsPage } from './pages/contractorPortal/ContractorPortalDocumentsPage'
import { PreOnboardingAirspacePage } from './pages/client/pre-auth/PreOnboardingAirspacePage'
import { useAuthTokens } from './hooks/useAuthTokens'
import { IntercomManager } from './components/intercom/IntercomManager'
import { HooksContainer } from './HooksContainer'
import { ClientSignInWithTokenPage } from './pages/client/auth/ClientSignInWithTokenPage'
import { ClientSignedUpPage } from './pages/client/auth/ClientSignedUpPage'
import { ClientSignedInPage } from './pages/client/auth/ClientSignedInPage'
import { ThemeOutlet } from './ThemeOutlet'
import { ContractorPortalContactDetailsPage } from './pages/contractorPortal/ContractorPortalContactDetailsPage'
import { ContractorPortalPaymentPage } from './pages/contractorPortal/ContractorPortalPaymentPage'

export const AppRoutes = () => {
  const { authToken, contractorPortalAuthToken } = useAuthTokens()

  return (
    <BrowserRouter>
      <Routes>
        {authToken ? (
          <Route path="/" element={<ThemeOutlet />}>
            <Route index element={<Navigate to="not-found" replace />} />

            <Route path={CLIENT_ROUTES.HOME_URL} element={<ClientHomePage />} />
            <Route path={CLIENT_ROUTES.DOCS_URL} element={<ClientDocsPage />} />
            <Route path={ONBOARDING_ROUTES.HOME_URL} element={<ClientHomePage />} />
            <Route path={ONBOARDING_ROUTES.DOCS_URL} element={<ClientDocsPage />} />
            <Route path={RECOLLECTION_ROUTES.DOCS_REUPLOAD_URL} element={<ClientDocsPage />} />
            <Route
              path={CLIENT_ROUTES.SIGN_IN_WITH_TOKEN_URL}
              element={<ClientSignInWithTokenPage />}
            />
            <Route path={CLIENT_ROUTES.SIGN_UP_URL} element={<ClientSignedUpPage />} />
            <Route path={CLIENT_ROUTES.SIGN_IN_URL} element={<ClientSignedInPage />} />
            <Route path="client/*" element={<Navigate to={CLIENT_ROUTES.HOME_URL} />} />
            <Route path="onboarding/*" element={<Navigate to={CLIENT_ROUTES.HOME_URL} />} />
            <Route path="recollection/*" element={<Navigate to={CLIENT_ROUTES.HOME_URL} />} />
          </Route>
        ) : (
          <Route path="/" element={<ThemeOutlet />}>
            <Route index element={<Navigate to="not-found" replace />} />

            <Route path={CLIENT_ROUTES.SIGN_IN_URL} element={<ClientSignInPage />} />
            <Route path={CLIENT_ROUTES.SIGN_UP_URL} element={<ClientSignUpPage />} />
            <Route path={ONBOARDING_ROUTES.SIGN_IN_URL} element={<ClientSignInPage />} />
            <Route path={RECOLLECTION_ROUTES.SIGN_IN_URL} element={<ClientSignInPage />} />
            <Route path={ONBOARDING_ROUTES.SIGN_UP_URL} element={<ClientSignUpPage />} />
            <Route
              path={CLIENT_ROUTES.ALREADY_REGISTERED_URL}
              element={<AlreadyRegisteredPage flow="client" />}
            />
            <Route path={CLIENT_ROUTES.ENTER_CODE_URL} element={<ClientEnterCodePage />} />
            <Route path={CLIENT_ROUTES.NOT_FOUND_URL} element={<NotFoundPage flow="client" />} />
            <Route path={CLIENT_ROUTES.LOGGED_OUT_URL} element={<LoggedOutPage flow="client" />} />
            <Route path={CLIENT_ROUTES.PARTNER_DISABLED_URL} element={<PartnerDisabledPage />} />
            <Route
              path={PRE_CLIENT_ROUTES.SELECT_CITY_URL}
              element={<PreOnboardingAirspacePage />}
            />
            <Route
              path={CLIENT_ROUTES.SIGN_IN_WITH_TOKEN_URL}
              element={<ClientSignInWithTokenPage />}
            />
            <Route path="client/*" element={<Navigate to={CLIENT_ROUTES.NOT_FOUND_URL} />} />
          </Route>
        )}
        {contractorPortalAuthToken ? (
          <Route path="/" element={<ThemeOutlet />}>
            <Route index element={<Navigate to="not-found" replace />} />

            <Route
              path={CONTRACTOR_PORTAL_ROUTES.HOME_URL}
              element={<ContractorPortalHomePage />}
            />
            <Route
              path={CONTRACTOR_PORTAL_ROUTES.INVOICES_URL}
              element={<ContractorPortalInvoicesPage />}
            />
            <Route
              path={CONTRACTOR_PORTAL_ROUTES.DOCUMENT_URL}
              element={<ContractorPortalDocumentsPage />}
            />
            <Route
              path={CONTRACTOR_PORTAL_ROUTES.PAYMENT_URL}
              element={<ContractorPortalPaymentPage />}
            />
            <Route
              path={CONTRACTOR_PORTAL_ROUTES.CONTACT_DETAILS_URL}
              element={<ContractorPortalContactDetailsPage />}
            />
            <Route
              path="contractor/*"
              element={<Navigate to={CONTRACTOR_PORTAL_ROUTES.HOME_URL} />}
            />
          </Route>
        ) : (
          <Route path="/" element={<ThemeOutlet />}>
            <Route index element={<Navigate to="not-found" replace />} />

            <Route
              path={CONTRACTOR_PORTAL_ROUTES.SIGN_IN_URL}
              element={<ContractorPortalSignInPage />}
            />
            <Route
              path={CONTRACTOR_PORTAL_ROUTES.SELECT_PARTNER_URL}
              element={<ContractorPortalSelectPartnerPage />}
            />
            <Route
              path={CONTRACTOR_PORTAL_ROUTES.ENTER_CODE_URL}
              element={<ContractorPortalEnterCodePage />}
            />
            <Route
              path={CONTRACTOR_PORTAL_ROUTES.PARTNER_DISABLED_URL}
              element={<PartnerDisabledPage />}
            />
            <Route
              path="contractor/*"
              element={<Navigate to={CONTRACTOR_PORTAL_ROUTES.SIGN_IN_URL} />}
            />
          </Route>
        )}
        <Route path="not-found" element={<NotFoundPage />} />
        <Route path="logged-out" element={<LoggedOutPage />} />
        <Route path="partner-disabled" element={<PartnerDisabledPage />} />
        <Route path="*" element={<Navigate to="not-found" />} />
      </Routes>
      <HooksContainer />
      <IntercomManager />
    </BrowserRouter>
  )
}
